
// CAUTION: auto generated by `set-env.ts`
export const environment = {
  production: true,
  apiPort:'',
  apiUrl: '/{{lang}}/graphql',
  mockApiUrl: 'undefined',
  localeUrl: '/{{lang}}/locale',
  kickstartFrontendPort: ':90',
  appVersion: 'build.2024-03-06.',
  langsPresentationOrder: ['fr', 'en'],
  urlPrefix: '/admin'
};
